module.exports = __webpack_public_path__ + "static/media/bg.38a1fae2.png";